import { LanguageCode } from '@/interfaces';

export enum RouteName {
  Home = 'Home',
  ArticleSummary = 'ArticleSummary',
  Article = 'Article',
  SignInWithLinkedIn = 'SignInWithLinkedIn',
  Verify = 'Verify',
  TrackMyParcelEn = 'TrackMyParcelEn',
  TrackMyParcelMultiLanguages = 'TrackMyParcelMultiLanguages',
  AccountEn = 'Account',
  AccountMultiLanguages = 'AccountMultiLanguages',
}

interface IRoute {
  path: string;
  component: any;
}

const ROUTES: Record<string, IRoute> = {
  [RouteName.Home]: {
    path: '/',
    component: async () => import('pages'),
  },
  [RouteName.ArticleSummary]: {
    path: '/[articleTypeSlug]',
    component: async () => import('pages/[articleTypeSlug]'),
  },
  [RouteName.Article]: {
    path: '/[articleTypeSlug]/[slug]',
    component: async () => import('pages/[articleTypeSlug]/[slug]'),
  },
  [RouteName.SignInWithLinkedIn]: {
    path: '/sign-in-with-linkedin',
    component: async () => import('pages/sign-in-with-linkedin'),
  },
  [RouteName.Verify]: {
    path: '/verify',
    component: async () => import('pages/verify'),
  },
  [RouteName.TrackMyParcelEn]: {
    path: '/track-my-parcel',
    component: async () => import('pages/track-my-parcel'),
  },
  [RouteName.TrackMyParcelMultiLanguages]: {
    path: '/[articleTypeSlug]/track-my-parcel',
    component: async () => import('pages/[articleTypeSlug]/track-my-parcel'),
  },
  [RouteName.AccountEn]: {
    path: '/account',
    component: async () => import('pages/account'),
  },
  [RouteName.AccountMultiLanguages]: {
    path: '/[articleTypeSlug]/account',
    component: async () => import('pages/[articleTypeSlug]/account'),
  },
};

export enum AmpPageType {
  country = 'country',
  carrier = 'carrier',
}

export enum SeoPageType {
  global = 'global',
  region = 'region',
  country = 'country',
  carrier = 'carrier',
}

export const SUPPORTED_LOCALES = [
  'zh',
  'nl',
  'en',
  'fr',
  'de',
  'el',
  'hi',
  'hu',
  'id',
  'it',
  'ja',
  'ko',
  'ms',
  'pl',
  'pt',
  'ro',
  'ru',
  'es',
  'ta',
  'th',
  'tr',
  'vi',
];

const LANGUAGE_CODES_GROUP = Object.values(LanguageCode);

export const MULTI_LANGUAGE_PAGE_SLUGS = ['track-my-parcel', 'account', 'manage-email-subscriptions'];

export const MULTI_LANGUAGE_PAGES_REGEX = new RegExp(
  `^/((${LANGUAGE_CODES_GROUP.join('|')})/)?(${MULTI_LANGUAGE_PAGE_SLUGS.join('|')})$`,
);

export default ROUTES;
